// ReelAndContainerInput.tsx
import React from 'react';
import { Form, Input,Grid } from 'semantic-ui-react';

// interface ReelAndContainerInputProps {
//   index:number;
//   containerBarcode: string;
//   reelCount: number;
//   onContainerBarcodeChange: (event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>, index: number) => void;
//   onReelCountChange: (event: React.ChangeEvent<HTMLInputElement>,index:number) => void;
//   handleAddContainer: (event: React.MouseEvent<HTMLButtonElement>) =>void
// }
interface FormValues {
  title: string;
  assetType: string;
  elementType: string;
  assetId: string;
  print: string;
  containerBarcodes:ContainerBarcode[];
  notes: string;
  [key: string]: string | ContainerBarcode[]; 
}

interface ContainerBarcode {
  container_barcode: string;
  reel_count: string;
  reel_barcode: string[];
}

interface ReelAndContainerInputProps {
  index: number;
  reelCount: number;
  onContainerBarcodeChange: (event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>, index: number) => void;
  onReelCountChange: (event: React.ChangeEvent<HTMLInputElement>, index: number) => void;
  handleAddContainer: (event: React.MouseEvent<HTMLButtonElement>) => void;
  formValues: {
    containerBarcodes:ContainerBarcode[]
    notes: string;
  };
  setFormValues: React.Dispatch<React.SetStateAction<FormValues>>

}

const ReelAndContainerInput: React.FC<ReelAndContainerInputProps> = ({ index, formValues,reelCount,setFormValues, onContainerBarcodeChange, onReelCountChange,}) => {

const handleReelInputChange = (containerIndex: number, reelIndex: number, e: React.ChangeEvent<HTMLInputElement>) => {
  const updatedContainerBarcodes = [...formValues.containerBarcodes];
  if (updatedContainerBarcodes[containerIndex].reel_barcode) {
    updatedContainerBarcodes[containerIndex].reel_barcode[reelIndex] = e.target.value;
  } else {
    updatedContainerBarcodes[containerIndex].reel_barcode = [];
    updatedContainerBarcodes[containerIndex].reel_barcode[reelIndex] = e.target.value;
  }

  setFormValues(prevState => ({
    ...prevState,
    containerBarcodes: updatedContainerBarcodes
  }));
};

const generateReelInputs = () => {
  const inputs = [];
  
  for (let i = 0; i < reelCount; i++) {
      inputs.push(
        <Grid stretched columns={1} style={{marginBottom: '10px'}}>
          <Grid.Column>
            <Form.Field key={i}>
                <label className="mandatory-label">Reel Barcode {i+1}</label>
                <Input
                    name={`reelInput${i}`}
                    placeholder={`Reel ${i+1}`}
                    value={`${formValues.containerBarcodes[index].reel_barcode[i]}`}
                    onChange={(e)=>handleReelInputChange(index, i, e)}
                />
            </Form.Field>
          </Grid.Column>
        </Grid>
      );
  }
  return inputs;
};

  return (
    <Form >
      <Grid stretched columns={2} style={{marginBottom: '10px'}}>
        <Grid.Column>
          <Form.Field>
            <label className="mandatory-label">Container Barcode</label>
            <Input
              name="container_barcode"
              placeholder="Container Barcode"
              onChange={(e)=>onContainerBarcodeChange(e,index)}
              value={formValues?.containerBarcodes[index]?.container_barcode}
            />
          </Form.Field>
        </Grid.Column>
        <Grid.Column>
          <Form.Field>
            <label className="mandatory-label">Reel Count</label>
            <Input
              type="number"
              name="reel_count"
              placeholder="Reel Count"
              value={formValues?.containerBarcodes[index]?.reel_count}
              onChange={(e:any)=>onReelCountChange(e,index)}
            />
          </Form.Field>
        </Grid.Column>
      </Grid>
      {generateReelInputs()}
    </Form>
  );
}

export default ReelAndContainerInput;
